import { styled as muiStyled } from "@mui/material";
import noteIcon from '../../../assets/noteIcon.svg'


const DefaultChoicesContainer = muiStyled("div")<{
  containerHeight?: String;
}>((theme: any) => ({
  height: theme.containerHeight,
  padding: "10px",
  display: "flex",
  alignItems: "center",
  backgroundColor: "#eae6ff",
  textAlign: "initial",
  marginTop: "16px"
}));

const DefaultChoicesImageContainer = muiStyled("div")({
  width: "50px",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const DefaultChoicesTextContainer = muiStyled("div")({
  width: "calc(100% - 50px)",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "14px",
  fontFamily: "Poppins",
});

const UploadZipFileNote = () => {
  return (
    <DefaultChoicesContainer>
      <DefaultChoicesImageContainer>
        <img alt="" src={noteIcon} />
      </DefaultChoicesImageContainer>
      <DefaultChoicesTextContainer>
        Note: Ensure the ZIP file contains all necessary project files, excluding dependency folders like node_modules, venv, or similar, and lock files such as package-lock.json, yarn.lock, etc.
      </DefaultChoicesTextContainer>
    </DefaultChoicesContainer>
  );
}

export default UploadZipFileNote;